import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@chakra-ui/react';
/** Per tone, only what the shared button recipe cannot say from the palette. */
const toneStyles = {
    // The recipe hovers a solid button with `colorPalette.fg`, which is the ink
    // itself on this palette: the hover needs its own step.
    solid: { _hover: { bg: 'agent.solidHover' } },
    outline: {},
    // "Ignorer" stays quieter than the gestures beside it.
    ghost: { color: 'agent.fgMuted', _hover: { bg: 'agent.subtle', color: 'agent.fg' } },
};
/**
 * The action of a companion block: the dashboard's Button on the `agent`
 * palette (a notice may hand it its own). Charcoal for the one gesture a block asks for, outlined for
 * "open", bare for "ignore". `sm` is the companion card's 36px call to
 * action, `xs` the 32px gesture inside a line.
 */
export function ActionButton({ tone = 'solid', size = 'sm', ...props }) {
    return (_jsx(Button, { colorPalette: "agent", variant: tone, size: size, fontFamily: "heading", ...toneStyles[tone], ...props }));
}
